import { IsAlphanumeric, IsOptional, IsNumber, IsNotEmpty } from "class-validator";
import { ApiProperty } from "@nestjs/swagger";

export class CertificationIdRequest{
     @ApiProperty()
     @IsNotEmpty()
     @IsAlphanumeric()
     certificationId: number;
    
     @ApiProperty()
     @IsOptional()
     updatedUser: string;
 
     @ApiProperty()
     @IsOptional()
     @IsNumber()
     versionFlag: number;
 
     @ApiProperty()
     isActive: boolean;

}